import React, { useEffect, useState } from 'react';
import { SuccessButton } from 'components/button';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps } from '__utils/type';
import { LayoutContext } from 'components/app-routes';
import { Row, Col } from 'antd';
import OrderSuccessIcon from '../../images/order-success-icon.svg';
import { addAgentCode, redirectToHome } from '__utils/common-utils';

import PaymentDetails from '../../components/payment-mode/payment-details';
import CalculatorSlider from 'components/calculator-slider';

const OuterContainer = styled.div<CommonStyledComponentProps>`
    .total-invest {
        display: flex;
        justify-content: space-between;
        margin: 16px;
    }
    .order-summary {
        padding: ${(props) => props.isMobile ? '16px' : '20px 20px 0'};
        background: white;
        fill: ${COLOR.WHITE};
        filter: drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.25));
        margin-bottom: ${(props) => props.isMobile ? '16px' : '40px'};
        border-radius: 8px;
    }
    .disclaimer {
        font-size: 12px;
        margin: 20px 0;
        padding: 9px 10px;
        background: #FDEFCE;
        border-left: 6px solid ${COLOR.WARNING_DARK};
    }
    .title-sec, .desc-sec {
        display: flex;
        justify-content: space-between;
    }
    .title-sec{
        color: ${COLOR.GREY3};
        line-height: normal;
        padding-bottom: 16px;
    }
    .desc-sec {
        padding-top: 16px;
        margin-bottom: 20px;
    }
    .desc-sec h3 {
        font-size: ${(props) => props.isMobile ? '14px' : ''};
        font-weight: 500;
        line-height: normal;
    }
    .title-sec + .desc-sec, .desc-sec + .desc-sec {
        border-top: 1px solid ${COLOR.DISABLED_BTN};
    }
    .desc-sec .investment-type {
        text-transform: uppercase;
    }
`
const SliderContainer = styled.div<CommonStyledComponentProps>`
    .calculator-sec {
        display: grid;
        margin: 60px auto 44px;
        grid-row-gap: 24px;
        background: transparent;
    }
    .calculator-top h3 {
        color: ${COLOR.BLACK};
        font-size: ${(props) => props.isMobile ? '16px' : '20px'};
        font-weight: 500;
        line-height: ${(props) => props.isMobile ? '24px' : '28px'};
    }
`

const ThankYou: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);
    const [orderSummaryValue, setOrderSummaryValue] = useState<any>();

    useEffect(() => {
        SetLayoutProps({
            config: {
                goBackCallback: () => redirectToHome(),
                title: <span>Thank you</span>,
            },
            showBseInfoForDesktop: false,
            showCopyrightInfoForDesktop: true,
            breadcrumbList: [ { text: 'Home', url: addAgentCode('v1/home'), isExternal: true }, { text: 'Thank you', url: '', isExternal: false } ]
        });
    }, []);

    const countTotalInvestment = (data: any)=>{
        setOrderSummaryValue(data);
    }

    const totalInvestmentHandler = () => {
        let totalInvestment = 0;
        orderSummaryValue?.data?.forEach((order: any) => {
          totalInvestment += +parseFloat(order?.amount).toFixed(2);
        });
        return totalInvestment;
    }

    return (
        <div>
            <OuterContainer isMobile={isMobile}>
                {isMobile && <h2 className='total-invest'>Total Investment 
                    <span>₹ {totalInvestmentHandler()}</span>
                </h2>}
                <div className='order-summary'>
                    <Row align="middle">
                        <Col className='order-placed-sec' md={2}>
                            <img src={OrderSuccessIcon} />
                        </Col>
                        <Col className='order-placed-sec' md={17}>
                            <h3>Your order has been placed.</h3>
                            <p>We have received your request and are processing it.</p>
                        </Col>
                        <Col md={5}>
                            {!isMobile &&
                                <SuccessButton onClick={() => redirectToHome()}>Back to Home</SuccessButton>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24}>
                            <p className='disclaimer'>Your scheme will show in portfolio after 2 days.</p>
                        </Col>
                    </Row>
                    <PaymentDetails pageType="success" onGetOrderSuccess={countTotalInvestment}/>
                </div>
                {isMobile &&  <div className="footer">
                        <SuccessButton onClick={() => redirectToHome()}>Back to Home</SuccessButton>
                    </div>
                }
            </OuterContainer>
            <SliderContainer isMobile={isMobile}>
                <div className={`calculator-sec ${isMobile ? 'mt30 p16' : ''}`}>
                    <div className={`calculator-top ${isMobile ? 'calc-mobile' : 'calc-desktop'}`}>
                        <h3>Explore our financial calculators</h3>
                    </div>
                    <CalculatorSlider />
                </div>
            </SliderContainer>
        </div>
        )};

export default ThankYou;